import { WebsiteBuilderData } from "api/websiteBuilderApi";
import { WebsiteBuilderContentType } from "Hooks/useWebsiteBuilder";
import Colors from "modules/Colors";
import { clsx, styx } from "modules/Utils";
import { CSSProperties } from "react";

interface WebsiteBuilderMiniatureProps {
    className: string;
    style?: CSSProperties;
    website: WebsiteBuilderData;
    onClick?: () => void;
}

const WebsiteBuilderMiniature = ({
    className,
    style,
    website,
    onClick,
}: WebsiteBuilderMiniatureProps) => {
    const {
        websiteContent,
        websiteStyle,
    } = website;

    const imageContentIndex = websiteContent.findIndex(content => content.type === WebsiteBuilderContentType.IMAGE);
    const musicContentIndex = websiteContent.findIndex(content => content.type === WebsiteBuilderContentType.MUSIC);
    
    const imageContent = imageContentIndex !== -1 ? websiteContent[imageContentIndex].imageContent : undefined;
    const musicContent = musicContentIndex !== -1 ? websiteContent[musicContentIndex].musicContent : undefined;

    let imageUrl;
    if (imageContentIndex !== -1 && musicContentIndex !== -1) {
        // Use the content that appears first in the array
        if (imageContentIndex < musicContentIndex) {
            imageUrl = imageContent?.image;
        } else {
            imageUrl = musicContent?.selectedMusic?.thumbnail_url;
        }
    } else {
        // If only one exists, use that one
        imageUrl = imageContent?.image || musicContent?.selectedMusic?.thumbnail_url;
    }

    const {
        backgroundColor,
        secondaryColor,
        textColor,
        fontFamily,
        textAlign,
    } = websiteStyle;

    // NOTE: render()
    return (
        <div
            className={clsx('websiteBuilderMiniatureComponent', className)}
            style={styx(
                sty.websiteBuilderSiteMiniature,
                { backgroundColor },
                style
            )}
            onClick={onClick}
        >
            {imageUrl &&
                <img
                    className="websiteBuilderMiniatureImage"
                    style={sty.websiteBuilderMiniatureImage}
                    src={imageUrl}
                    alt="Website Builder Miniature"
                />
            }
            <div
                className="smallBlock1"
                style={styx(sty.smallBlock1, { backgroundColor: secondaryColor })}
            />
            <div
                className="smallBlock2"
                style={styx(sty.smallBlock2, { backgroundColor: secondaryColor })}
            />
            <div
                className="smallBlockContainer"
                style={sty.smallBlockContainer}
            >
                <div
                    className="smallBlock3"
                    style={styx(sty.smallBlock3, { backgroundColor: secondaryColor })}
                >
                    <div
                        className="smallBlock3_inner"
                        style={styx(sty.smallBlock3_inner, { backgroundColor: textColor })}
                    />
                </div>
                <div
                    className="smallBlock3"
                    style={styx(sty.smallBlock3, { backgroundColor: secondaryColor })}
                >
                    <div
                        className="smallBlock3_inner"
                        style={styx(sty.smallBlock3_inner, { backgroundColor: textColor })}
                    />
                </div>
            </div>
        </div>
    )
}

const sty: Record<string, CSSProperties> = {
    websiteBuilderSiteMiniature: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2,
        width: 38,
        height: 64,
        paddingLeft: 4,
        paddingRight: 4,
        paddingTop: 6,
        paddingBottom: 4,
        borderRadius: 6,
        backgroundColor: Colors.purple,
        flexShrink: 0,
    },
    websiteBuilderMiniatureImage: {
        width: 20,
        height: 20,
        objectFit: 'cover',
        borderRadius: 2,
    },
    smallBlock1: {
        width: 8,
        height: 4,
        borderRadius: 100,
        backgroundColor: Colors.purple,
    },
    smallBlock2: {
        width: 12,
        height: 4,
        borderRadius: 100,
        backgroundColor: Colors.purple,
    },
    smallBlockContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        gap: 2,
    },
    smallBlock3: {
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        borderRadius: 2,
        backgroundColor: Colors.purple,
        padding: 2,
    },
    smallBlock3_inner: {
        width: '60%',
        height: 3,
        borderRadius: 100,
        backgroundColor: Colors.purple,
    },
}

export default WebsiteBuilderMiniature;